module.exports = __webpack_public_path__ + "img/jwgl-jcsj-xqgl.6528f36d.png";